import { Skeleton } from "@/components/ui";

export const AlertsSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 px-3 py-2"
      data-testid="alerts-skeleton"
    >
      <div className="flex gap-2">
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-6 w-24" />
      </div>
    </div>
  );
};
